import { getBoughtTickets } from '../stores/backend';

export const useBoughtTickets = getBoughtTickets;
